import React from "react";
import { toast } from "react-toastify";
import { Form, Stack } from "react-bootstrap";
import { useSelector } from "react-redux";
import ProductTableView from "./ProductTableView";

export default function QuantityCard({ setData, DataArr, attr }) {
  const groupedData = DataArr.reduce((acc, item) => {
    const personName = item.personOfTreatment.value;
    if (!acc[personName]) {
      acc[personName] = [];
    }
    acc[personName].push(item);
    return acc;
  }, {});

  const result = Object.keys(groupedData).map((key) => ({
    name: key,
    array: groupedData[key],
  }));
  const { quichReportData } = useSelector((state) => state.QUICKREPORT);

  const handleQuantityChange = (e, index) => {
    let data = [...DataArr];
    let newQuantity = Number(e.target.value);
    if (newQuantity < 1) {
      toast.error("Minimum quantity is 1");
      return;
    }
    const currentProduct = quichReportData?.products?.find(
      (item) => item.description === data[index]?.item?.value
    );
    if (currentProduct && newQuantity > currentProduct?.current_quantity) {
      toast.error(`Maximum quantity is ${currentProduct?.current_quantity}`);
      return;
    }
    data[index] = {
      ...data[index],
      quantity: {
        ...data[index].quantity,
        value: newQuantity,
      },
    };

    attr === "quickAdd"
      ? setData((prev) => ({
          ...prev,
          formDataArray: data,
        }))
      : setData([...data]);
  };

  const getTableBody = (data) => {
    if (data?.length > 0) {
      const tableBody = data?.map((itemData, index) => {
        return {
          cell: [
            {
              data: <h6 className="m-0"> {itemData?.item?.value}</h6>,
              align: "start",
            },
            {
              data: (
                <Stack
                  direction="horizontal"
                  className="justify-content-center"
                >
                  <Form.Control
                    type="number"
                    value={itemData?.quantity?.value}
                    min="1"
                    placeholder="Qty"
                    onChange={(e) => {
                      handleQuantityChange(e, index);
                    }}
                    size="sm"
                    style={{ width: "70px", height: "40px" }}
                    className="text-center"
                  />
                </Stack>
              ),
              align: "center",
            },
          ],
        };
      });
      return tableBody;
    } else {
      return [];
    }
  };

  return (
    <Stack className="mt-3 row-gap-3">
      {result.map((item, index) => {
        return (
          <ProductTableView
            key={index}
            tableHeader={[
              { name: `Used by ${item.name}`, align: "left" },
              { name: "Quantity", align: "center" },
            ]}
            tableBody={getTableBody(item.array)}
          />
        );
      })}
    </Stack>
  );
}
